export const isMobile = () => {

    if(window.innerWidth < 700) {
        return true
    }

    return false

}
